import { useCallback } from "react";
import type { LocalProgress } from "../types/assessment";

const STORAGE_KEY = "assessmentProgress";
const EMAIL_KEY = "assessmentEmail";
const PENDING_FINISH_KEY = "assessmentPendingFinish";

export function useLocalPersistence() {
  const save = useCallback((progress: LocalProgress) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
    if (progress.email) {
      localStorage.setItem(EMAIL_KEY, progress.email);
    }
  }, []);

  const load = useCallback((): LocalProgress | null => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as LocalProgress;
    } catch {
      return null;
    }
  }, []);

  const loadEmail = useCallback((): string | null => {
    return localStorage.getItem(EMAIL_KEY);
  }, []);

  const clear = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(EMAIL_KEY);
    localStorage.removeItem(PENDING_FINISH_KEY);
  }, []);

  const setPendingFinish = useCallback((sessionId: string) => {
    localStorage.setItem(PENDING_FINISH_KEY, sessionId);
  }, []);

  const getPendingFinish = useCallback((): string | null => {
    return localStorage.getItem(PENDING_FINISH_KEY);
  }, []);

  const clearPendingFinish = useCallback(() => {
    localStorage.removeItem(PENDING_FINISH_KEY);
  }, []);

  return {
    save,
    load,
    loadEmail,
    clear,
    setPendingFinish,
    getPendingFinish,
    clearPendingFinish,
  };
}
